import './index.css'; // Import the custom tooltip
import React from 'react';
import Card from '../Card';
import ChartHeader from './ChartHeader';
import ChartProvider from './ChartProvider';
import ChartMain from './ChartMain';

const HGChart = ({ devices }) => {
    return (
        <ChartProvider devices={devices}>
            <div className="w-full">
                <Card customClasses="py-5 px-5 min-h-[503px]">
                    <ChartHeader />
                    <ChartMain />
                </Card>
            </div>
        </ChartProvider>
    );
};

export default HGChart;
